const SectionDivider = ({ className="mt-2" }) => {
  return (
    <hr
      className={`${className} border-edge-gray-200 dark:border-edge-gray-700`}
    />
  );
};

export default SectionDivider;
